import "./ErrorPage.scss";
import { useEffect } from "react";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import { useNavigate } from "react-router-dom";
import ArrowBtn from "../../components/arrowbtn/ArrowBtn";
import WOW from "wow.js";

const ErrorPage = () => {
const navigate = useNavigate();

useEffect(() => {
  const wow = new WOW();
  wow.init();
}, []);

  return (
    <PageLayout>
    <section className="error_page">
      <div className="content_wrap p_top p_bottom">
        <h1 className="wow fadeInUp">404</h1>
        <p className="wow fadeInUp"  data-wow-delay="0.15s">Sorry!, The Page you are looking for is not available.</p>
        <ArrowBtn
          text="Home"
          handleClick={() => navigate("/")}
          theme="secondary_ternery"
          classList="wow fadeInUp"
          delay="0.3"
        />
      </div>
    </section>
    </PageLayout>
  );
};

export default ErrorPage;
